import React, { useEffect, useState, useCallback } from "react";
import TemplateForm from "./TemplateForm";
import ObjectList from "../../Common/ObjectList";
import ObjectListMobile from "../../Common/ObjectListMobile";
import http from "../../Common/RestAPIHandler";
import {templateLang} from "../../Common/Languages";

const lang = localStorage.getItem("languages");

const tableColumns = [
  {
    id: "title",
    label: templateLang.TITLE[lang],
    minWidth: 200,
    sortable: true,
  },
  {
    id: "template_type_name",
    label: templateLang.TYPENAME[lang],
    minWidth: 200,
    sortable: true,
  },
  { id: "created_by_name", label: templateLang.BY[lang], minWidth: 150, sortable: true },
];

const Template = (props) => {
  const [data, setData] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const url = `templates`;
  const actions = {
    delete: true,
    importCSV: false,
    exportCSV: false,
    exportPDF: false,
  };

  const fetchData = useCallback(() => {
    setLoadData(true);
    http.Get(
      url,
      (data) => {
        setData(data);
        setLoadData(false);
      },
      () => {
        setLoadData(false);
      }
    );
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <>
    {!props.mobile && 
    <ObjectList
      {...props}
      moduleName={templateLang.Templates[lang]}
      url={url}
      actions={actions}
      permissions={{ create: [], edit: [], delete: [] }}
      tableColumns={tableColumns}
      data={data}
      fetchData={fetchData}
      objectForm={TemplateForm}
      orderBy={"title"}
      searchFields={["title"]}
      pageHeader={(props.user.company_name || "") + " | Templates"}
      loadData={loadData}
    />
    }
    {props.mobile && 
    <ObjectListMobile
      {...props}
      moduleName={"Templates"}
      url={url}
      actions={actions}
      permissions={{ create: [], edit: [], delete: [] }}
      tableColumns={tableColumns}
      data={data}
      fetchData={fetchData}
      objectForm={TemplateForm}
      orderBy={"title"}
      searchFields={["title"]}
      pageHeader={(props.user.company_name || "") + " | Templates"}
      loadData={loadData}
    />
    }
    </>
  );
};

export default Template;
